export default "__VITE_ASSET__DZznuzZl__"